// extracted by mini-css-extract-plugin
export default {"container":"po-z","bubbleNav":"qo-z","graphic":"ro-z","contact":"so-z"};